var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\n<form class=\"document-form\">\n  <div class=\"articles-of-incorporation-container\"></div>\n  <div class=\"bylaws-container\"></div>\n</form>";
},"useData":true});